<template>
  <div id="app">
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>
<script>

  export default {
    name: "Home",
    components: {
    },
    data() {
      return {

      };
    },

    mounted() { },
    methods: {


    },
  };
</Script>
<style lang="less">
  /* #html{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  } */
  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: "Source Han Sans CN", "思源黑体", "Microsoft YaHei", "微软雅黑", sans-serif;
  }

  input,
  button {
    font-family: inherit;
  }
</style>